import { Button, message } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ChooseStoreToGetDataRealTimeAdmin.scss";
import ChooseStoreToGetDataRealTimeGrid from "./components/ChooseStoreToGetDataRealTimeGrid";
import ChooseStoreToGetDataRealTimeItem from "./components/ChooseStoreToGetDataRealTimeItem";
import { mixPostV1 } from "../../services/mixin";
// import PaymentModal from '../../components/Modal/PaymentModal'

const ChooseStoreToGetDataRealTimeAdmin: React.FC = () => {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [owners, setOwners] = useState<any[]>([]);
  const [searchText, setSearchText] = useState("");
  const [ownerFilter, setOwnerFilter] = useState("");
  // const [storeId, setStoreId] = useState(null as any)

  const getStore = async () => {
    const res = await mixPostV1("/api/webAdmin/gComboStoreByOwner.php", {
      owner_id: user.id,
    });
    if (res.status === 1) {
      setOwners(res.data);
      const allStores = res.data.flatMap((owner: any) => owner.listStore || []);
      localStorage.setItem("stores", JSON.stringify(allStores));
    }
  };

  useEffect(() => {
    getStore();
  }, []);

  const choseStore = async (
    val: number,
    typeId: any,
    service_id = 0,
  ) => {
    const param = {
      owner_id: user.id,
      store_id: val,
    };
    const res = await mixPostV1("/api/webAdmin/createTokenAdmin.php", param);
    if (res.status === 1) {
      localStorage.setItem("token", res.token);
      localStorage.setItem("storeId", val.toString());
      localStorage.setItem("storeTypeId", typeId.toString());
      localStorage.setItem("service_id", service_id.toString());
      window.location.href = "/";
    } else {
      messageApi.open({
        type: "error",
        content: res.message,
      });
    }
  };

  const handleOwnerFilterChange = (value: string) => {
    setOwnerFilter(value);
  };

  // MODAL PAYMENT
  // const [showPaymentModal, setShowPaymentModal] = useState(false)

  return (
    <>
      {contextHolder}
      <div className="choose-store-page">
        <div className="choose-store-page-container">
          <figure className="logo">
            <img src="/images/logo.png" alt="" />
          </figure>
          <Button
            className="rs-button default-outlined go-back"
            onClick={() => navigate("/login")}
          >
            Back
          </Button>
          <div className="title">Choose your store to get data real-time</div>

          {/* Search + Filter */}
          <div className="store-filters">
            <div style={{ position: "relative", width: "500px" }}>
              <input
                type="text"
                placeholder="Search by Store name"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="store-search-input"
              />
              <span className="search-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="11" cy="11" r="7" stroke="#222" strokeWidth="2" />
                  <line
                    x1="16.018"
                    y1="16.4853"
                    x2="21"
                    y2="21.4673"
                    stroke="#222"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
            </div>
            <div
              style={{
                position: "relative",
                width: "220px",
                display: "inline-block",
              }}
            >
              <select
                value={ownerFilter}
                onChange={(e) => handleOwnerFilterChange(e.target.value)}
                className="store-filter-select"
              >
                <option value="" disabled hidden>
                  Filter by Owner
                </option>
                {owners.map((owner: any) => (
                  <option key={owner.id} value={owner.owner_name}>
                    {owner.owner_name}
                  </option>
                ))}
              </select>
              {ownerFilter && (
                <button
                  type="button"
                  className="clear-owner-btn"
                  onClick={() => setOwnerFilter("")}
                  aria-label="Clear owner"
                >
                  ×
                </button>
              )}
            </div>
          </div>

          {/* Group by Owner */}
          {owners
            .filter((owner) => {
              return ownerFilter === "" || owner.owner_name === ownerFilter;
            })
            .map((owner) => {
              const stores = (owner.listStore || []).filter((store: any) =>
                store.store_name
                  .toLowerCase()
                  .includes(searchText.toLowerCase()),
              );

              if (stores.length === 0) return null;

              return (
                <div key={owner.id} className="store-group">
                  <div className="store-group-header">
                    <span className="store-group-label">
                      {owner.owner_name}
                    </span>
                  </div>
                  <ChooseStoreToGetDataRealTimeGrid>
                    {stores.map((item: any) => (
                      <ChooseStoreToGetDataRealTimeItem
                        key={item.store_id}
                        name={item.store_name}
                        address={item.address}
                        storeId={item.store_id}
                        status={item.status}
                        status_name={item.status_name}
                        // disabled={item.status !== 1}
                        onSelect={(e: number) =>
                          choseStore(
                            e,
                            item.type_id,
                            item?.service_id,
                          )
                        }
                        // onShowModal={(e) => {
                        //     setShowPaymentModal(true)
                        //     setStoreId(e)
                        // }}
                      />
                    ))}
                  </ChooseStoreToGetDataRealTimeGrid>
                </div>
              );
            })}
        </div>
      </div>

      {/* <PaymentModal
                storeId={storeId}
                isShow={showPaymentModal}
                onModalClose={() => setShowPaymentModal(false)}
                onModalSubmit={() => { setShowPaymentModal(false); getStore() }}
            /> */}
    </>
  );
};

export default ChooseStoreToGetDataRealTimeAdmin;
